import TitleM from "@common/components/text/TitleM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import React, { useContext } from "react"
import { View } from "react-native"

export const ProfileSection = ({
    title,
    children,
    style,
    noBorder = false,
    tiny = false,
    rightComponent = null,
}) => {
    const dimensions = useContext(DimensionsContext)

    return (
        <View
            style={{
                paddingHorizontal: 15,
                paddingVertical: tiny ? 5 : 20,
                alignItems: "flex-start",
                justifyContent: "flex-start",
                borderBottomWidth: noBorder ? 0 : 1,
                borderColor: theme.colors.lightMore,
                width: dimensions?.width,
                ...style,
            }}
        >
            {(title || rightComponent) && (
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                    }}
                >
                    {title && (
                        <TitleM
                            style={{
                                flex: 1,
                                fontSize: tiny ? 16 : 20,
                            }}
                            color={tiny ? theme.colors.grey : theme.colors.primary}
                            fontWeight="Bold"
                        >
                            {title}{" "}
                        </TitleM>
                    )}
                    {rightComponent}
                </View>
            )}

            {children}
        </View>
    )
}
